// src/components/GoogleMap.js
import React from "react";
import "./GoogleMap.css";
import shopPhoto from "../assets/shop_photo.jpg";
import { FaMapMarkerAlt } from "react-icons/fa";

const GoogleMap = () => {
  return (
    <div className="google-map-container">
      {/* Google Map - Will appear first on mobile */}
      <div className="map-container">
        <iframe
          title="Kothari Luggage Mall Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3749.1634279993627!2d73.77361707500239!3d20.001654481402998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddeb013af2e74b%3A0xe61d440807c70c5b!2sKothari%60s%20Luggage%20Mall!5e0!3m2!1sen!2sin!4v1742241045720!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>

      {/* Shop Info - Will appear second on mobile */}
      <div className="shop-info">
        <img src={shopPhoto} alt="Kothari Luggage Mall" className="shop-image" />
        <div className="address-container">
          <div className="address-line">
            <FaMapMarkerAlt className="location-icon" />
            <strong>Kothari Luggage Mall</strong>
          </div>
          <div className="address-details">
            Utility Center, Opposite Rajiv Gandhi Bhavan,<br />
            Tilak Wadi, Canada Corner, Nashik, Maharashtra 422002.
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleMap;